export default __webpack_public_path__ + "static/media/DarkReload.c6f79102.svg";